import { render, staticRenderFns } from "./revisePassword.vue?vue&type=template&id=09275c34&scoped=true&"
import script from "./revisePassword.vue?vue&type=script&lang=js&"
export * from "./revisePassword.vue?vue&type=script&lang=js&"
import style0 from "./revisePassword.vue?vue&type=style&index=0&id=09275c34&prod&lang=scss&scoped=true&"
import style1 from "./revisePassword.vue?vue&type=style&index=1&id=09275c34&prod&scoped=true&lang=css&"
import style2 from "./revisePassword.vue?vue&type=style&index=2&id=09275c34&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09275c34",
  null
  
)

export default component.exports